import { useEffect, useRef } from 'react';

/**
 * CursorGlow - A premium cursor glow effect that follows the mouse
 * Inspired by Linear, Vercel, and Awwwards winners
 */
const CursorGlow = () => {
  const glowRef = useRef(null);
  const trailRef = useRef(null);
  const posRef = useRef({ x: 0, y: 0 });
  const targetRef = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const glow = glowRef.current;
    const trail = trailRef.current;
    if (!glow || !trail) return;

    let animationId;

    const handleMouseMove = (e) => {
      targetRef.current = { x: e.clientX, y: e.clientY };
    };

    // Smooth lerp animation
    const animate = () => {
      const lerp = 0.15; // Smoothing factor

      posRef.current.x += (targetRef.current.x - posRef.current.x) * lerp;
      posRef.current.y += (targetRef.current.y - posRef.current.y) * lerp;

      // Main glow follows cursor closely
      glow.style.transform = `translate(${targetRef.current.x}px, ${targetRef.current.y}px)`;

      // Trail follows with lag
      trail.style.transform = `translate(${posRef.current.x}px, ${posRef.current.y}px)`;

      animationId = requestAnimationFrame(animate);
    };

    window.addEventListener('mousemove', handleMouseMove, { passive: true });
    animationId = requestAnimationFrame(animate);

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <>
      {/* Main glow - follows cursor tightly */}
      <div
        ref={glowRef}
        className="pointer-events-none fixed -translate-x-1/2 -translate-y-1/2 z-[9999] mix-blend-screen"
        style={{
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(34, 211, 238, 0.15) 0%, rgba(59, 130, 246, 0.08) 30%, transparent 70%)',
          filter: 'blur(1px)',
          willChange: 'transform',
        }}
      />
      {/* Trail glow - follows with smooth delay */}
      <div
        ref={trailRef}
        className="pointer-events-none fixed -translate-x-1/2 -translate-y-1/2 z-[9998]"
        style={{
          width: '600px',
          height: '600px',
          background: 'radial-gradient(circle, rgba(139, 92, 246, 0.08) 0%, rgba(34, 211, 238, 0.04) 40%, transparent 70%)',
          filter: 'blur(2px)',
          willChange: 'transform',
        }}
      />
    </>
  );
};

export default CursorGlow;
